import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/icd-supply-request-form";

export const pagingICDMedicalSupplyRequestForm = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getICDMedicalSupplyRequestFormById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdate = iCDMedicalSupplyRequestForm => axios.post(API_PATH + '/save', iCDMedicalSupplyRequestForm);

export const deleteICDMedicalSupplyRequestForm = id => axios.delete(API_PATH + '/mark-delete/' + id);

export const getAllICDMedicalSupplyRequestForms = () => axios.get(API_PATH + "/get-all")